export const HomeSvg = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="14" r="11.5" stroke="#EBEBF5" />
      <circle cx="15" cy="14" r="7.75" stroke="#EBEBF5" stroke-width="0.5" />
    </svg>
  );
};
